class Customer.AutomaticRefreshTime extends Backbone.Model
  defaults:
    id: 0
    name: ''
    text: ''
    value: 0

  initialize: (attributes) ->
    super attributes
